module.exports = __webpack_public_path__ + "static/img/cd4013-1.1bc75f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/cd4013-1.svg
// module id = i/Y2
// module chunks = 0